import { dataBell } from 'dls-icons-data'
import { createIcon } from '../common'

const IconBell = /*#__PURE__*/createIcon(dataBell)
export default IconBell
